import { RootState } from '../configureStore';

export const selectToken = (state: RootState) => {
  const token = state.auth.token;
   return token;
};

export const selectUser = (state: RootState) => state.auth.user;
export const selectUserEmail = (state: RootState) => state.auth.user?.email || null;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectAuthError = (state: RootState) => state.auth.error;
export const selectAuthLoading = (state: RootState) => state.auth.isLoading;
